// ProjectDetailsMobileWrapper.js
import React from "react";
import { useParams } from "react-router-dom";
import ProjectDetailsMobile from "./ProjectDetailsMobile";

const ProjectDetailsMobileWrapper = () => {
  const { slug } = useParams();
  return <ProjectDetailsMobile slug={slug} />;
};

export default ProjectDetailsMobileWrapper;
